<template>
  <div
    class="calico-upload-file"
  >
    <CalicoFileDropzone
      :accept="accept"
      @browse="onBrowse"
    />
    <label
      v-if="files.length"
      class="label--small bold"
    >Uploading {{ files.filter(file => file.progress !== 100).length }}/{{ files.length }} Files</label>
    <CalicoFileItem
      v-for="(document, index) in files"
      :key="index"
      :progress="document.progress"
      :completed="!!document.id"
      :error="!!document.message"
      :name="document.name"
      :message="document.message"
      @cancel="onCancel(document)"
      @trash="onTrash(document)"
    />
    <label
      v-if="file"
      class="label--small bold"
    >Uploading 1/1 Files</label>
    <CalicoFileItem
      v-if="file"
      :progress="file.progress"
      :completed="!!file.id"
      :error="!!file.message"
      :name="file.name"
      :message="file.message"
      @cancel="onCancel(file)"
      @trash="onTrash(file)"
    />
  </div>
</template>

<script lang="js">

import CalicoFileDropzone from '@/components/calico/fileDropzone/index.vue'
import CalicoFileItem from '@/components/calico/fileItem/index.vue'

export default {
  name: 'CalicoUploadFile',
  components: {
    CalicoFileDropzone,
    CalicoFileItem
  },
  props: {
    size: {
      type: Number,
      default: null
    },
    accept: {
      type: String,
      default: ''
    },
    file: {
      type: Object,
      default: null
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      uploading: 0
    }
  },
  methods: {
    onBrowse(files) {
      files = [...Object.values(files)]
      files = files.map((file) => ({
        file,
        name: file.name,
        progress: 0
      }))

      this.$emit('browse', files)
    },
    onCancel (file) {
      this.$emit('cancel', file)
    },
    onTrash (file) {
      this.$emit('trash', file)
    }
  }
}
</script>

<style lang="scss">
.calico-upload-file {
  @include stack-space($space-medium);
  align-items: center;
  width: 100%;
  label {
    margin: 0px;
  }
}
</style>